<template>
  <div id="reset">
    <!-- 忘记账户 -->
    <el-row class="logincenter">
      <el-col :span="8">&nbsp;</el-col>
      <el-col :span="8" style="text-align:center">
        <div class="login-form">
          <div class="filed left">
            <i class="iconfont icou"></i>
            <span class="formTitleStyle">账户重置申请</span>
            <span class="signstyle"><a @click="open">返回登录</a></span>
          </div>
          <form ref="loginForm" id="loginForm" autocomplete="off" name="loginform" method="post">
            <div class="filed">
              <el-input v-model="REAcompanyName" name="REAcompanyName" id="REAcompanyName" placeholder="单位名称"
                prefix-icon="iconfont icon-login-danwei" @blur="dwmcCheck"></el-input>
              <p class="alert" v-show="dwmcAlertFlag">*请输入单位名称</p>
            </div>
            <div class="filed">
              <el-input v-model="REAunscid" name="REAunscid" id="REAunscid" placeholder="统一社会信用代码" prefix-icon="iconfont icon-login-tyshxydm"
                @blur="tyshxydmCheck"></el-input>
              <p class="alert1" v-show="tyshxydmAlertFlag">*统一社会信用代码为18位数字字母组合</p>
            </div>
            <div class="filed">
              <el-input placeholder="新手机号" v-model="username" prefix-icon="iconfont icon-login-username" @blur="mobileCheck"
                class="iconStyle"></el-input>
              <p class="alert" v-show="usernameAlertFlag">*请输入正确手机号</p>
            </div>
            <div class="filed lgin">
              <el-button type="danger" @click="REAIdentify()" round>提交审核</el-button>
            </div>
          </form>
        </div>
      </el-col>
      <el-col :span="8">&nbsp;</el-col>
    </el-row>
  </div>
</template>

<script>
  export default {
    name: 'Login',
    data() {
      return {
        //重置账户
        REAcompanyName: "",
        REAunscid: "",
        username: "",
        //重置校验标识
        dwmcAlertFlag: false,
        tyshxydmAlertFlag: false,
        usernameAlertFlag: false,
        currentUser: this.CONSTANT.currentUser
      }
    },
    methods: {
      //消息提示框
      open() {
        if (this.REAcompanyName != '' || this.REAunscid != '') {
          this.$confirm("未保存的数据将丢失，确定返回吗？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.$router.push({
              path: "/exhibition/login/ch/login"
            });
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消'
            });
          });
        } else {
          this.$router.push({
            path: "/exhibition/login/ch/login"
          });
        }
      },
      // 验证用户名是否为手机号
      mobileCheck() {
        if (!/^1[3456789]\d{9}$/.test(this.username)) {
          //用户名不正确，显示红字提醒
          this.usernameAlertFlag = true;
          return false;
        } else {
          this.usernameAlertFlag = false;
          return true;
        }
      },
      //单位名称校验
      dwmcCheck: function() {
        if (this.REAcompanyName == null || this.REAcompanyName == '') {
          this.dwmcAlertFlag = true;
        } else {
          this.dwmcAlertFlag = false;
        }
      },

      //统一社会信用代码校验
      tyshxydmCheck: function() {
        if (!(/^[A-Za-z0-9 ]{18}$/.test(this.REAunscid))) {
          this.tyshxydmAlertFlag = true;
        } else {
          this.tyshxydmAlertFlag = false;
        }
      },

      //忘记账户
      REAIdentify() {
        let vm = this;
        if (this.REAcompanyName == null || this.REAcompanyName == '') {
          this.dwmcAlertFlag = true;
        } else if (!(/^[A-Za-z0-9 ]{18}$/.test(this.REAunscid))) {
          this.tyshxydmAlertFlag = true;
        } else if (!/^1[3456789]\d{9}$/.test(vm.username)) {
          vm.usernameAlertFlag = true;
        }  else {
          var params = {
            tyshxydm: this.REAunscid,
            zwgsmc: this.REAcompanyName,
            newsj: this.username,
            shzt: "01"
          }
          vm.$axios.post('/qybg/insertQyBgByVO', params).then(function(res) {
            if (res.data.code === "00000000") {
              vm.$alert('重置账户成功！初始密码为 您的手机号@cfpa 请登录系统后通过右上角-个人中心及时修改初始密码。', {
                confirmButtonText: '确定',
                type: 'success'
              }).then(() => {
                vm.$router.push({name: "exhibition/login/ch/Login"})
              });
            } else {
              if (res.data.msg) {
                if (res.data.msg == "本企业使用手机号与新手机号一致,请重置密码") {
                  vm.$alert(res.data.msg, {
                    confirmButtonText: '确定',
                    type: 'warning'
                  }).then(() => {
                    vm.$router.push({
                      path: "/exhibition/login/ch/ForgetPassword"
                    });
                  });
                } else {
                  vm.$alert(res.data.msg, {
                    confirmButtonText: '确定',
                    type: 'warning'
                  })
                }
                
              } else {
                vm.$alert("提交失败，请稍后再试", {
                  confirmButtonText: '确定',
                  type: 'warning'
                })
              }
            }
          }.bind(this), function(error) {
            console.log(error);
          });
        }
      },
    }
  }
</script>

<style lang="scss">
  #reset {
    @import '@/common/scss/login.scss';

    .lgin {
      margin-top: 9rem;
    }
    a {
      text-decoration: none;
      color: #2452ff;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/exhibition/login/ch/Reset.vue